import * as types from "../constants/ActionTypes";
import {isoDurationToMinutes} from "../public/journey1/definition/helper";

const initialState = {
  customer: {},
  generalInformation: {},
  selectedOptions: [],
  estimatedTime: 0,
  towing: false
};

const initialStateSave = {
  showAppointmentModal: false,
  showMessageAppointmentModal: false,
};

export function createAppointmentRequest(state = initialState, action) {
  switch (action.type) {
    case 'SAVE.RESET_APPOINTMENT_REQUEST':
      return {
        ...initialState,
        generalInformation: {...action.params},
      };
    case types.SAVE_CUSTOMER_INFORMATION:
      return {
        ...state,
        customer: {...state.customer, ...action.params},
      };
    case types.SAVE_GENERAL_INFORMATION:
      return {
        ...state,
        generalInformation: {...state.generalInformation, ...action.params},
      };
    case types.SAVE_COMMENT:
      return {
        ...state,
        comment: action.payload
      };
    case types.FETCH_CALL_CENTER_VEHICLE_PROPERTIES_SUCCESS:
      return {
        ...state,
        generalInformation: {...state.generalInformation, ...action.payload}
      };
    case types.FETCH_CUSTOMER_INFORMATION_SUCCESS:
      return {
        ...state,
        customer: {
          ...state.customer,
          lastname: action.payload.customer && action.payload.customer.lastName,
          firstname: action.payload.customer && action.payload.customer.firstName,
          ...action.payload.customer},
        generalInformation: {...state.generalInformation, licensePlate: action.payload.vehicle.licensePlate}
      };
    case 'REMOVE.MOBILITY_OPTION':
      const {chosenMobility, ...rest} = state;
      return {
        ...rest
      }
    case 'SAVE.MOBILITY_OPTION':
      return {
        ...state,
        chosenMobility: {...action.params}
      };
    case types.SAVE_DATE_APPOINTMENT:
      return {
        ...state,
        date: {...state.date, ...action.payload}
      };
    case 'SAVE.RECEPTION_APPOINTMENT':
      return {
        ...state,
        ...action.params
      };
    case 'SAVE.TOWING':
      return {
        ...state,
        towing: action.params
      }
    case 'SAVE.SET_SERVICE':
      return {
        ...state,
        selectedOptions: [action.params.selectedService],
        estimatedTime: computeDuration([action.params.selectedService]),
      };
    case 'SAVE.TIRE_EXCHANGE':
      return {
        ...state,
        tiresExchange: {...state.tiresExchange, ...action.params}
      };
    case 'SAVE.ADD_SERVICE':
      const selectedOptions = [...state.selectedOptions, action.params.selectedService];
      return {
        ...state,
        selectedOptions,
        estimatedTime: computeDuration(selectedOptions),
      };
    case 'SAVE.REMOVE_SERVICE':
      const filteredOptions = state.selectedOptions.filter(e => e.id !== action.params.name);
      return {
        ...state,
        selectedOptions: filteredOptions,
        estimatedTime: computeDuration(filteredOptions),
      };
    case 'SAVE.TIRE_REPLACEMENT':
      return {
        ...state,
        tireReplacement: {...state.tireReplacement, ...action.params}
      };
    case 'SAVE.PERSONAL_INFORMATION':
      return {
        ...state,
        personalInformation: {...state.personalInformation, ...action.params}
      }
    case types.HIDE_APPOINTMENT_CREATION_MODAL:
      return {
        ...initialState,
      };
    case types.HIDE_MESSAGE_APPOINTMENT_CREATION_MODAL:
      return {
        ...initialState
      };
    default:
      return state
  }
}

export function saveAppointment(state = initialStateSave, action) {
  switch (action.type) {
    case types.SAVE_CALL_CENTER_APPOINTMENT_SUCCESS:
      return {
        ...state,
      };
    case types.SHOW_APPOINTMENT_CREATION_MODAL:
      return {
        ...state,
        showAppointmentModal: true,
      };
    case types.HIDE_APPOINTMENT_CREATION_MODAL:
      return {
        ...state,
        showAppointmentModal: false,
      };
    default:
      return state
  }
}

export function saveMessageAppointment(state = initialStateSave, action) {
  switch (action.type) {
    case types.SAVE_CALL_CENTER_MESSAGE_APPOINTMENT_SUCCESS:
      return {
        ...state,
      };
    case types.SHOW_MESSAGE_APPOINTMENT_CREATION_MODAL:
      return {
        ...state,
        showMessageAppointmentModal: true,
      };
    case types.HIDE_MESSAGE_APPOINTMENT_CREATION_MODAL:
      return {
        ...state,
        showMessageAppointmentModal: false,
      };
    default:
      return state
  }
}

function computeDuration(selectedServices) {
  return selectedServices.map(o => isoDurationToMinutes(o.duration))
    .reduce((accumulator, currentValue) => accumulator + currentValue, 0);
}



// WEBPACK FOOTER //
// ./src/reducers/createAppointment.js